export default __webpack_public_path__ + "static/media/listbuilder-thunder-selected.e76c872e.svg";